import { uniqBy } from "es-toolkit";

import type { GetParentContextById } from "../../state/index.ts";
import type {
  AvailableActionDefinition,
  DesignerNode,
  GetManifestByTypeId,
  NodeDesignerDescr,
} from "../../types/index.ts";

interface CreateOptions {
  getManifest: GetManifestByTypeId;
  getParentContext: GetParentContextById;
}

export const getNodeAvailableActionsCreate = ({ getManifest, getParentContext }: CreateOptions) => {
  // framework dispatch by typeId: the node is the framework view (bare
  // DesignerNode); TDescr types the returned action definitions only
  return <TDescr extends NodeDesignerDescr>(node: DesignerNode): AvailableActionDefinition<TDescr>[] => {
    const {
      designer: { getAvailableActions },
    } = getManifest(node.typeId);
    if (!getAvailableActions) return [];

    const parentContext = getParentContext(node.id);

    const actions: AvailableActionDefinition[] = getAvailableActions(node, { parentContext });
    const uniqueActions = uniqBy(actions, (a) => `${a.name}${a.id}`);
    if (uniqueActions.length < actions.length) {
      console.warn(
        `Node Designer ${node.id}:${node.typeId} returned non-unique available actions from getAvailableActions.`,
        actions,
      );
    }
    // because id can be a number we need to make it a string for later lookup
    return uniqueActions.map((a) => ({ ...a, id: a.id?.toString() }));
  };
};

export type GetNodeAvailableActions = ReturnType<typeof getNodeAvailableActionsCreate>;
